export type SpringState = {
	value: number
	prevValue: number
	settled: boolean
}

const defaultDT = 1 / 60

export const spring = (
	value: number,
	targetValue: number,
	prevValue = 0,
	deltaTime = defaultDT,
	mass = 1,
	stiffness = 0.8,
	damping = 0.25
): SpringState => {
	const delta = targetValue - value
	const velocity = (value - prevValue) / (deltaTime || defaultDT)
	const springForce = stiffness * delta
	const dampForce = damping * velocity
	const acceleration = (springForce - dampForce) * mass
	const d = (velocity + acceleration) * deltaTime

	return Math.abs(d) < 0.5 && Math.abs(delta) < 0.5
		? { value, prevValue: value, settled: true }
		: { value: value + d, prevValue: value, settled: false }
}
